import alt, { AltStoreModel } from '../../alt';
import FeedbackActions from './feedback_actions';
import Feedback from '../feedback';
import FeedbackSummary from '../feedback_summary';
import { get } from 'lodash';

interface State {
  feedbacks: Feedback[];
  feedbackSummary: FeedbackSummary;
  visibleFeedbacks: string;
  nextFeedbacks: string;
  loaded: boolean;
}

const ALL_FEEDBACK = 'all';
const BUYER_FEEDBACK = 'buyer';
const SELLER_FEEDBACK = 'seller';

class FeedbackStore extends AltStoreModel<State> implements State {
  feedbacks = [];

  feedbackSummary = null;

  nextFeedbacks = null;

  visibleFeedbacks = 'all';

  loaded = false;

  constructor() {
    super();
    this.bindActions(FeedbackActions);
  }

  onLoadAllFeedback() {
    this.setState({
      feedbacks: [],
      visibleFeedbacks: ALL_FEEDBACK,
      loaded: false,
    });
  }

  onLoadBuyerFeedback() {
    this.setState({
      feedbacks: [],
      visibleFeedbacks: BUYER_FEEDBACK,
      loaded: false,
    });
  }

  onLoadSellerFeedback() {
    this.setState({
      feedbacks: [],
      visibleFeedbacks: SELLER_FEEDBACK,
      loaded: false,
    });
  }

  onSummaryLoaded(response) {
    this.setState({
      feedbackSummary: response,
    });
  }

  onLoaded(response) {
    this.setState({
      feedbacks: this.feedbacks.concat(response.feedbacks),
      nextFeedbacks: get(response, '_links.next.href'),
      loaded: true,
    });
  }
}

export default alt.createStore(FeedbackStore, 'FeedbackStore');
